import { HBO_ELIGIBLE_ACTIVATION_STATUSES } from '../constants';
import { useHboActivationContext } from '../context/HboActivationContext';

// Unica fuente de la elegibilidad para activar HBO Max. El status del Context ya viene gateado
// por useHboActivationStatus (feature flag + perfil Administrador + suscripcion HBO activa),
// asi que alcanza con evaluar el estado de activacion.
// Solo lee lo que el Provider ya resolvio: nunca dispara una consulta de estado por si mismo.
export const useHboEligibleStatus = () => {
  const hboActivation = useHboActivationContext();

  // Fuera del arbol de NodesLayout no hay Provider: no es elegible, pero tampoco queda cargando
  const loading = Boolean(hboActivation?.loading);
  const isEligible =
    !loading &&
    HBO_ELIGIBLE_ACTIVATION_STATUSES.includes(hboActivation?.status);

  return { isEligible, loading };
};
